import { IntersectionRuleConfiguration } from "./IntersectionRuleConfiguration";
import { DataDefinition } from "../../Common/Data/DataDefinition";
import { IContext } from "../../Common/IContext";
import { IDesignPanelConfig } from "../../Common/IDesignPanelConfig";
import { RuleBuilderPage } from "../RuleBuilderPage";
import { StateManager } from "../../Common/StateManager";
import { DialogProps } from "../../Common/DialogProps";
import { ILinkingData } from "../ILinkingData";
import type { AppGlueAny } from "../../Common/AppGlueAny";

export class IntersectionRuleEditContext implements IContext {
    designConfig?: IDesignPanelConfig | undefined;
    runtimeConfig?: IDesignPanelConfig | undefined;
    clipboardElement: AppGlueAny;
    lastSelectionElement: AppGlueAny;

    inputDataDefinition?: DataDefinition;
    outputDataDefinition?: DataDefinition;

    mode: RuleBuilderPage = RuleBuilderPage.Rule;
    title?: string;
    definition: IntersectionRuleConfiguration;
    public onRuleSave?: () => void;
    public onRuleCancel?: () => void;
    _openLinkingDialog: boolean = false;

    constructor(def: IntersectionRuleConfiguration) {
        this.definition = def;
    }

    _notification: DialogProps | undefined;

    get notification() {
        return this._notification;
    }

    set notification(notification: DialogProps | undefined) {
        this._notification = notification;
        StateManager.propertyChanged(this, "notification");
    }

    get openLinkDialog() {
        return this._openLinkingDialog;
    }

    set openLinkDialog(open: boolean) {
        this._openLinkingDialog = open;
        StateManager.propertyChanged(this, "openLinkDialog");
    }

    _linkData: ILinkingData = {
        period: "every_day",
        periodData: {
            period: "day",
            times: 0,
            onWeekDays: [],
            at: "1",
            value: 1,
        },
        storeData: true,
        serviceSetting: false,
        format: "csv",
    };

    get linkData() {
        return this._linkData;
    }

    set linkData(data: ILinkingData) {
        this._linkData = data;
        StateManager.propertyChanged(this, "linkData");
    }

    // eslint-disable-next-line
    onCopy(id?: string) {}

    // eslint-disable-next-line
    onCut(id?: string) {}

    // eslint-disable-next-line
    onDelete(id?: string) {}

    // eslint-disable-next-line
    onPaste(id?: string) {}
}
